<template>
    <div class="column is-12 mb-2">
        <div class="card">
            <div class="card-content">
                <p class="title mb-1 is-6">
                    {{ viewing.Subject }}
                </p>

                <p v-if="viewing.MemFeedback">
                    Feedback: {{ viewing.MemFeedback }}
                </p>

                <p
                    v-if="viewing.Start"
                    class="subtitle mt-1 is-7"
                >
                    <small class="is-size-7 has-text-grey">
                        {{ viewing.Start | formatDateTime }}
                    </small>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        viewing: {
            type: Object,
            required: true,
        },
    },
};
</script>
